import { handleRetrieveWebinar } from "../../../../redux/admin-slices/webinars.slice"
import { FILE_PATH_URI, handleDownload } from "../../../../utils/helper"
import SkeletonImage from "../../../../components/common/SkeletonImage"
import { Link, Link as NavLink, useParams } from "react-router-dom"
import DocViewer from "../../../../components/common/DocViewer"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../../assets/js/Icons"
import { useEffect, useState } from "react"

import {
  Avatar, Box, Container, Grid2 as Grid, IconButton, Table,
  TableBody, TableCell, TableContainer, TableRow, Typography
} from "@mui/material"
import moment from "moment"
import Bookings from "./bookings"

function SingleWebinar() {
  const dispatch = useDispatch()
  const { id: webinarId } = useParams()
  const [webinar, setWebinar] = useState({})
  const { refresh } = useSelector(state => state.otherSlice)

  // Handle retrieve webinar
  const handleRetrieve = async () => {
    const { webinar } = await dispatch(handleRetrieveWebinar(webinarId)).unwrap() || {}
    if (webinar) { setWebinar(webinar) }
  }

  useEffect(() => {
    handleRetrieve()
    // eslint-disable-next-line
  }, [refresh])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box
        sx={{
          p: 3,
          width: "100%",
          overflow: "hidden",
          borderRadius: "12px",
          border: "1px solid #00000012",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid size={{ xs: 12, md: "auto" }}>
            <Box
              sx={{
                p: 0.5,
                bottom: "0",
                border: "2px solid",
                left: { xs: "20px" },
                borderRadius: "100px",
                display: "inline-block",
                borderColor: "primary.main",
              }}
            >
              <Avatar
                sx={{
                  width: { xs: 50, md: 100 },
                  height: { xs: 50, md: 100 },
                }}
                src={webinar?.user?.image?.startsWith("http") ? webinar?.user?.image : webinar?.user?.image ? FILE_PATH_URI + webinar?.user?.image : ""}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }}>
            <Typography
              fontSize={28}
              fontWeight="700"
              textTransform="capitalize"
            >{webinar?.user?.fullName}
            </Typography>
            <Typography><b>Email : </b>{webinar?.user?.email}</Typography>
          </Grid>
        </Grid>

        <Box sx={{ pt: 3 }}>
          <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>Webinar details</Typography>
          <TableContainer
            className="adminTable2"
          // sx={{ "tr:last-child :is(td, th)": { borderBottom: "none" } }}
          >
            <Table stickyHeader>
              <TableBody>
                <TableRow>
                  <TableCell component="th">Title</TableCell>
                  <TableCell>{webinar?.details?.title}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Description</TableCell>
                  <TableCell sx={{ whiteSpace: "normal !important" }}>{webinar?.details?.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Number Of Seats</TableCell>
                  <TableCell>{webinar?.details?.numberOfSeats}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Cover image</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        width: "250px",
                        borderRadius: 2,
                        overflow: "hidden",
                        aspectRatio: "1/1",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      {webinar?.details?.coverImage?.path &&
                        <IconButton
                          sx={{
                            top: "10px",
                            right: "10px",
                            border: "1px solid",
                            position: "absolute",
                            color: "primary.main",
                            bgcolor: "white !important",
                            borderColor: "primary.main"
                          }}
                          size="small"
                          onClick={() => { handleDownload(FILE_PATH_URI + webinar?.details?.coverImage?.path) }}
                        ><Icons.CloudDownloadSolid />
                        </IconButton>
                      }
                      <SkeletonImage src={FILE_PATH_URI + webinar?.details?.coverImage?.path} />
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Date</TableCell>
                  <TableCell>{moment(webinar?.schedule?.date).format("YYYY-MM-DD")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Start time</TableCell>
                  <TableCell>{moment(webinar?.schedule?.startTime).format("MMM DD YYYY [at] hh:mm A")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Duration</TableCell>
                  <TableCell>{webinar?.schedule?.duration || 0} mins</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Format</TableCell>
                  <TableCell>{webinar?.format?.format}</TableCell>
                </TableRow>
                {webinar?.resources?.webinarLink &&
                  <TableRow>
                    <TableCell component="th">Webinar link</TableCell>
                    <TableCell sx={{ whiteSpace: "normal !important" }}>
                      <Link
                        target="_blank"
                        component={NavLink}
                        rel="noopener noreferrer"
                        style={{ color: "inherit" }}
                        to={webinar?.resources?.webinarLink}
                      >{webinar?.resources?.webinarLink}
                      </Link>
                    </TableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </TableContainer>

          <Bookings />
        </Box>
      </Box>

      <DocViewer />
    </Container>
  )
}

export default SingleWebinar